import { render, staticRenderFns } from "./ServiceByGameIdModel.vue?vue&type=template&id=c9f8709c&scoped=true"
import script from "./ServiceByGameIdModel.vue?vue&type=script&lang=js"
export * from "./ServiceByGameIdModel.vue?vue&type=script&lang=js"
import style0 from "./ServiceByGameIdModel.vue?vue&type=style&index=0&id=c9f8709c&prod&lang=scss"
import style1 from "./ServiceByGameIdModel.vue?vue&type=style&index=1&id=c9f8709c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9f8709c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PzImage: require('/drone/src/components/PzImage/index.vue').default})
